import type { LucideIcon } from 'lucide-react'
import {
  BriefcaseIcon,
  Building2Icon,
  CircleEllipsisIcon,
  CoffeeIcon,
  FactoryIcon,
  PillIcon,
  ScissorsIcon,
  ShoppingCartIcon,
  StethoscopeIcon,
  StoreIcon,
  UtensilsCrossedIcon,
  WineIcon,
} from 'lucide-react'

export type BusinessTypeOption = {
  label: string
  description: string
  icon: LucideIcon
}

/** Inbox that receives demo requests. */
export const demoRequestInbox = 'contact@kayko.rw'

export const demoBusinessTypes: BusinessTypeOption[] = [
  { label: 'Restaurant', description: 'Table service and takeaways', icon: UtensilsCrossedIcon },
  { label: 'Café', description: 'Coffee shops and bakery counters', icon: CoffeeIcon },
  { label: 'Bar', description: 'Bars, pubs and lounges', icon: WineIcon },
  { label: 'Hotel', description: 'Hotels, lodges and apartments', icon: Building2Icon },
  { label: 'Retail shop', description: 'Boutiques, hardware and general stores', icon: StoreIcon },
  { label: 'Supermarket', description: 'Mini markets and grocery stores', icon: ShoppingCartIcon },
  { label: 'Pharmacy', description: 'Pharmacies and drug shops', icon: PillIcon },
  { label: 'Clinic', description: 'Clinics, dental and medical practices', icon: StethoscopeIcon },
  { label: 'Salon & spa', description: 'Hair, beauty and wellness', icon: ScissorsIcon },
  { label: 'Manufacturing', description: 'Production, workshops and processing', icon: FactoryIcon },
  { label: 'Professional services', description: 'Agencies, consultants and repairs', icon: BriefcaseIcon },
  { label: 'Other', description: 'Something else', icon: CircleEllipsisIcon },
]
